/* eslint-disable @typescript-eslint/no-explicit-any */
import tiktok from '@bridge/tiktok';
import { isCsr } from '@fe/armor_utils';
import { ShareOptions } from '.';
import { isInApp } from './utils';
import { emitCounter } from './slardar';
export interface UserInfo {
  app_id: string;
  avatar_url: string;
  bind_phone: string;
  bind_phone_region: string;
  code: number;
  dp_level: number;
  isChildMode: string;
  isSupportMV: boolean;
  is_login: boolean;
  is_private_account: boolean;
  login: boolean;
  nickname: string;
  openid: string;
  recvJsCallTime: string;
  respJsTime: string;
  sec_user_id: string;
  unique_id: string;
  user_id: string;
}
interface AppInfo {
  aid: string;
  appName: string;
  appVersion: string;
  channel: string;
  code: number;
  device_id: string;
  device_platform: string;
  device_type: string;
  ironManSupported: number;
  netType: string;
  os_version: string;
  recvJsCallTime: string;
  respJsTime: string;
  time_system: string;
  user_id: string;
  versionCode: string;
}

const jsbPromise = (method, options) => new Promise((resolve, reject) => {
  if (window.ToutiaoJSBridge) {
    window.ToutiaoJSBridge.call(method, options, res => {
      resolve(res);
    });
  } else {
    reject({
      error: 'ToutiaoJSBridge is not a function'
    });
  }
});

export function replaceURL(href: string) {
  try {
    closeWebView();
    openWebView(href);
  } catch (err) {}
}
export function getUserInfo() {
  return ((tiktok.app.getUserInfo() as unknown) as Promise<UserInfo>);
}
export function getAppInfo() {
  if (!isInApp()) {
    return Promise.resolve(({} as AppInfo));
  }

  return ((tiktok.app.getAppInfo() as unknown) as Promise<{
    aid: string;
    appName: string;
    appVersion: string;
    channel: string;
    code: number;
    device_id: string;
    device_platform: string;
    device_type: string;
    ironManSupported: number;
    netType: string;
    os_version: string;
    recvJsCallTime: string;
    respJsTime: string;
    time_system: string;
    user_id: string;
    versionCode: string;
  }>);
}
export const closeWebView = (reactId = '') => {
  return tiktok.app.close({
    reactId
  });
};
export function openSchema(schema?: string) {
  if (!schema) {
    return;
  }

  return tiktok.app.openSchema({
    reactId: schema,
    schema
  });
}
export function openLogin(options?: any) {
  return (tiktok.app.openLoginWithCallback as (any) => Promise<{
    success: boolean;
  }>)(options);
}
export function openWebView(url?: string) {
  if (!url) {
    return;
  }

  if (!/^https?:\/\//.test(url)) {
    url = window.location.origin + url;
  }

  return tiktok.app.openSchema({
    reactId: url,
    schema: `aweme://webview?url=${encodeURIComponent(url)}`
  });
}
export function launchChat(uid: string) {
  return tiktok.app.launchChat({
    uid
  });
}
export function launchShoot(from: string) {
  return openSchema(`aweme://openRecord?from=${from}&enter_from=${from}`);
}
export function openVideoList(id: string, list: string[], from?: string) {
  return tiktok.app.openVideoItemList({
    react_id: from || 'test',
    aweme_id_list: list,
    current_aweme_id: id,
    enter_from: from || '',
    tracker_data: ''
  });
}
export function openSingleVideo(id: string) {
  return tiktok.app.openVideoItem({
    item_id: id
  });
}
export function bridgeFetch(option: any) {
  return tiktok.app.fetch(option);
}
export async function setAppStatusBarBlack() {
  return tiktok.app.darkMode({
    reactId: '',
    useDarkMode: true
  });
}
export async function setAppStatusBarWhite() {
  return tiktok.app.darkMode({
    reactId: '',
    useDarkMode: false
  });
}
export function share(options: Partial<ShareOptions>) {
  return tiktok.app.share({
    platform: 'share_native',
    ...(options as any)
  });
}
export async function isAppInstalled(open_url: string) {
  const {
    installed
  } = await tiktok.app.isOtherAppInstalled({
    open_url
  });
  return installed === 1;
}
export function verificationCheck() {
  return (jsbPromise('verificationCheck', {
    verifyCode: 99999
  }) as Promise<{
    code: number;
    data: {
      result: boolean;
    };
  }>);
}
export const sendLog = (eventName: string, params?: {
  [key: string]: any;
}) => {
  if (isCsr() && isInApp()) {
    tiktok.app.sendLogV3({
      eventName,
      params: params || {}
    });
  }

  emitCounter(eventName, 1, params || {});
};
export function follow(uid: string, sec_uid: string, type = 1) {
  return tiktok.app.syncSpecActFollowStatus({
    uid,
    sec_uid,
    type
  });
}
export function addEventListener(eventName: string, cb: (params: {
  panel_frame: {
    panel_height: number;
  };
}) => void) {
  tiktok.on(eventName, cb);
}
export async function toast(message: string, type: 'success' | 'error' = 'success') {
  return tiktok.app.showToast({
    message,
    type
  });
}